<template>
  <div class="header-electronic py-3 text-black relative">
    <div class="w-full">
      <span class="text-xl font-bold" v-if="person">
        <span>{{ person.name }}</span> -
        <span>{{ person.medical_record_name }}</span>
        <span v-if="getBADT" @click="showModalUpdateBenhAn(true)" class="mx-3 cursor-pointer">
          <svg
            class="mr-2"
            width="18"
            height="19"
            viewBox="0 0 18 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15.75 9.95357C15.5511 9.95357 15.3603 10.0326 15.2197 10.1732C15.079 10.3139 15 10.5047 15 10.7036V15.2036C15 15.4025 14.921 15.5932 14.7803 15.7339C14.6397 15.8746 14.4489 15.9536 14.25 15.9536H3.75C3.55109 15.9536 3.36032 15.8746 3.21967 15.7339C3.07902 15.5932 3 15.4025 3 15.2036V4.70357C3 4.50466 3.07902 4.31389 3.21967 4.17324C3.36032 4.03259 3.55109 3.95357 3.75 3.95357H8.25C8.44891 3.95357 8.63968 3.87455 8.78033 3.7339C8.92098 3.59325 9 3.40248 9 3.20357C9 3.00466 8.92098 2.81389 8.78033 2.67324C8.63968 2.53259 8.44891 2.45357 8.25 2.45357H3.75C3.15326 2.45357 2.58097 2.69062 2.15901 3.11258C1.73705 3.53453 1.5 4.10683 1.5 4.70357V15.2036C1.5 15.8003 1.73705 16.3726 2.15901 16.7946C2.58097 17.2165 3.15326 17.4536 3.75 17.4536H14.25C14.8467 17.4536 15.419 17.2165 15.841 16.7946C16.2629 16.3726 16.5 15.8003 16.5 15.2036V10.7036C16.5 10.5047 16.421 10.3139 16.2803 10.1732C16.1397 10.0326 15.9489 9.95357 15.75 9.95357ZM4.5 10.5236V13.7036C4.5 13.9025 4.57902 14.0932 4.71967 14.2339C4.86032 14.3746 5.05109 14.4536 5.25 14.4536H8.43C8.5287 14.4541 8.62655 14.4352 8.71793 14.3979C8.80931 14.3606 8.89242 14.3056 8.9625 14.2361L14.1525 9.03857L16.2825 6.95357C16.3528 6.88385 16.4086 6.80089 16.4467 6.7095C16.4847 6.61811 16.5043 6.52008 16.5043 6.42107C16.5043 6.32206 16.4847 6.22403 16.4467 6.13263C16.4086 6.04124 16.3528 5.95829 16.2825 5.88857L13.1025 2.67107C13.0328 2.60077 12.9498 2.54498 12.8584 2.5069C12.767 2.46882 12.669 2.44922 12.57 2.44922C12.471 2.44922 12.373 2.46882 12.2816 2.5069C12.1902 2.54498 12.1072 2.60077 12.0375 2.67107L9.9225 4.79357L4.7175 9.99107C4.64799 10.0611 4.59299 10.1443 4.55567 10.2356C4.51835 10.327 4.49943 10.4249 4.5 10.5236ZM12.57 4.26107L14.6925 6.38357L13.6275 7.44857L11.505 5.32607L12.57 4.26107ZM6 10.8311L10.4475 6.38357L12.57 8.50607L8.1225 12.9536H6V10.8311Z"
              fill="#20419B"
            />
          </svg>
          <span class="text-black fs-14 mr-3 cursor-pointer fw-600">Chỉnh sửa bệnh án</span>
        </span>
        <template v-if="hasVimesSync">
          <div
            class="inline-block text-black fs-14 mr-3 cursor-pointer fw-600"
            :class="{
              'pointer-events-none': isSyncing,
            }"
            @click="handleSyncVimes()"
          >
            <span class="align-middle mr-2">
              <i v-if="isSyncing" class="el-icon-loading text-lg" />
              <i v-else class="el-icon-refresh text-lg" />
            </span>
            <span class="align-middle">Đồng bộ dữ liệu Vimes</span>
          </div>
        </template>
        <template v-if="hasEHCConnect">
          <div
            class="inline-block text-black fs-14 mr-3 cursor-pointer fw-600"
            :class="{
              'pointer-events-none': isEhcSyncing,
            }"
            @click="handleSyncEhcMedicalRecords()"
          >
            <span class="align-middle mr-2">
              <i v-if="isEhcSyncing" class="el-icon-loading text-lg" />
              <i v-else class="el-icon-refresh text-lg" />
            </span>
            <span class="align-middle">Đồng bộ dữ liệu Hola HIS</span>
          </div>
        </template>
      </span>

      <div class="row mt-2 font-semibold">
        <div class="col-md-2">
          <div>
            {{
            `${getGender()}${getYear()} ${
            getAge() ? `(${getAge()} tuổi)` : ""
            } `
            }}
          </div>
          <div v-if="addressPerson">
            <span class="font-normal">{{ addressPerson }}</span>
          </div>
        </div>
        <div class="col-md-2">
          SĐT:
          <span class="font-normal mx-2">{{ person.phone }}</span>
        </div>
        <div class="col-md-2">
          CCCD:
          <span class="font-normal mx-2">{{ person.cmnd }}</span>
        </div>
        <div class="col-md-3">
          BHYT:
          <span class="font-normal mx-2">{{ person.insurance_number }}</span>
        </div>
        <div class="col-md-3">
          PID:
          <span class="font-normal mx-2">{{ person.person_ref_id }}</span>
        </div>
      </div>
      <div class="row mt-2 font-semibold">
        <div class="col-md-3 space-x-5 flex items-center">
          Phòng:
          <span class="font-normal" v-show="person.admission_room">
            {{
            person.admission_room
            }}
          </span>
          <span class="ml-3">
            Giường:
            <span class="font-normal" v-show="person.admission_bed">
              {{
              person.admission_bed
              }}
            </span>
          </span>
        </div>
        <div class="col-md-3 flex items-center">
          Bác sĩ Trưởng khoa/ Bác sĩ chính:
          <span class="font-normal mx-2">
            {{
            (getBADT.main_doctor && getBADT.main_doctor.name) ||
            getBADT.main_doctor_name
            }}
          </span>
        </div>
        <div class="col-md-3 flex items-center">
          Bác sĩ Điều trị:
          <span class="font-normal mx-2">
            {{
            (getBADT.treat_doctor && getBADT.treat_doctor.name) ||
            getBADT.treat_doctor_name
            }}
          </span>
        </div>
        <div class="col-md-3 flex items-center">
          <span class="mr-3">Trạng thái:</span>
          <el-dropdown trigger="click" placement="bottom" @command="setStatusMR">
            <div
              class="el-dropdown-link font-normal flex items-center text-white w-full h-ful px-2 py-1 border border-solid rounded"
              v-if="!statusName"
              :class="getClassStatusMR(person.status)"
            >
              <span class="w-32 block">{{ getStatusMR(person.status) }}</span>
              <i class="el-icon-arrow-down el-icon--right"></i>
            </div>
            <div
              v-else
              class="el-dropdown-link font-normal flex items-center text-white w-full h-ful px-2 py-1 border border-solid rounded"
              :class="statusName.class"
            >
              <span class="w-32 block">{{ statusName.name }}</span>
              <i class="el-icon-arrow-down el-icon--right"></i>
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(item, index) in statuses"
                :key="index + 'status'"
                :command="item"
              >
                <span>{{ item.name }}</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>

      <div class="mt-3" v-if="false">
        <div class="flex space-x-3">
          <!-- Grid view -->
          <div class="w-6 h-6 cursor-pointer" @click="goToMode()">
            <el-tooltip content="Grid View" placement="top">
              <svg
                width="25"
                height="25"
                viewBox="0 0 25 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.3877 13.4204H3.3877C3.12248 13.4204 2.86812 13.5258 2.68059 13.7133C2.49305 13.9008 2.3877 14.1552 2.3877 14.4204V21.4204C2.3877 21.6856 2.49305 21.94 2.68059 22.1275C2.86812 22.3151 3.12248 22.4204 3.3877 22.4204H10.3877C10.6529 22.4204 10.9073 22.3151 11.0948 22.1275C11.2823 21.94 11.3877 21.6856 11.3877 21.4204V14.4204C11.3877 14.1552 11.2823 13.9008 11.0948 13.7133C10.9073 13.5258 10.6529 13.4204 10.3877 13.4204ZM9.3877 20.4204H4.3877V15.4204H9.3877V20.4204ZM21.3877 2.42041H14.3877C14.1225 2.42041 13.8681 2.52577 13.6806 2.7133C13.4931 2.90084 13.3877 3.15519 13.3877 3.42041V10.4204C13.3877 10.6856 13.4931 10.94 13.6806 11.1275C13.8681 11.3151 14.1225 11.4204 14.3877 11.4204H21.3877C21.6529 11.4204 21.9073 11.3151 22.0948 11.1275C22.2823 10.94 22.3877 10.6856 22.3877 10.4204V3.42041C22.3877 3.15519 22.2823 2.90084 22.0948 2.7133C21.9073 2.52577 21.6529 2.42041 21.3877 2.42041ZM20.3877 9.42041H15.3877V4.42041H20.3877V9.42041ZM21.3877 13.4204H14.3877C14.1225 13.4204 13.8681 13.5258 13.6806 13.7133C13.4931 13.9008 13.3877 14.1552 13.3877 14.4204V21.4204C13.3877 21.6856 13.4931 21.94 13.6806 22.1275C13.8681 22.3151 14.1225 22.4204 14.3877 22.4204H21.3877C21.6529 22.4204 21.9073 22.3151 22.0948 22.1275C22.2823 21.94 22.3877 21.6856 22.3877 21.4204V14.4204C22.3877 14.1552 22.2823 13.9008 22.0948 13.7133C21.9073 13.5258 21.6529 13.4204 21.3877 13.4204ZM20.3877 20.4204H15.3877V15.4204H20.3877V20.4204ZM10.3877 2.42041H3.3877C3.12248 2.42041 2.86812 2.52577 2.68059 2.7133C2.49305 2.90084 2.3877 3.15519 2.3877 3.42041V10.4204C2.3877 10.6856 2.49305 10.94 2.68059 11.1275C2.86812 11.3151 3.12248 11.4204 3.3877 11.4204H10.3877C10.6529 11.4204 10.9073 11.3151 11.0948 11.1275C11.2823 10.94 11.3877 10.6856 11.3877 10.4204V3.42041C11.3877 3.15519 11.2823 2.90084 11.0948 2.7133C10.9073 2.52577 10.6529 2.42041 10.3877 2.42041ZM9.3877 9.42041H4.3877V4.42041H9.3877V9.42041Z"
                  :fill="
                    !modeView || modeView === 'grid' ? '#2A5BAD' : '#33363F'
                  "
                />
              </svg>
            </el-tooltip>
          </div>
          <!--  -->
          <!-- Map View -->
          <div class="w-6 h-6 cursor-pointer" @click="goToMode('map')">
            <el-tooltip content="Map View" placement="top">
              <svg
                width="25"
                height="25"
                viewBox="0 0 25 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.3306 11.1076C10.3001 10.3312 10.3058 9.51917 10.3225 8.84227C10.917 9.16627 11.6231 9.56735 12.2803 9.98201C12.7603 10.2849 13.1977 10.5847 13.5409 10.8583C13.9109 11.1534 14.077 11.3452 14.1203 11.4203C14.1636 11.4953 14.2467 11.7351 14.3172 12.2031C14.3827 12.6371 14.4236 13.1657 14.4459 13.7329C14.4764 14.5094 14.4707 15.3214 14.454 15.9983C13.8595 15.6743 13.1534 15.2732 12.4962 14.8585C12.0162 14.5556 11.5788 14.2559 11.2356 13.9822C10.8656 13.6871 10.6995 13.4953 10.6562 13.4203C10.6129 13.3452 10.5298 13.1055 10.4593 12.6375C10.3939 12.2035 10.3529 11.6748 10.3306 11.1076Z"
                  :stroke="modeView === 'map' ? '#2A5BAD' : '#33363F'"
                  stroke-width="2"
                />
                <circle
                  cx="12.3877"
                  cy="12.4204"
                  r="9"
                  :stroke="modeView === 'map' ? '#2A5BAD' : '#33363F'"
                  stroke-width="2"
                />
              </svg>
            </el-tooltip>
          </div>
          <!--  -->
          <!-- Tree view -->
          <div class="w-6 h-6 cursor-pointer" @click="goToMode('tree')">
            <el-tooltip content="Tree View" placement="top">
              <svg
                width="25"
                height="25"
                viewBox="0 0 25 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4.09793 16.7104C4.00282 16.6194 3.89068 16.548 3.76793 16.5004C3.52447 16.4004 3.25139 16.4004 3.00793 16.5004C2.88518 16.548 2.77303 16.6194 2.67793 16.7104C2.58689 16.8055 2.51552 16.9177 2.46793 17.0404C2.39135 17.2225 2.37043 17.4232 2.4078 17.6172C2.44517 17.8112 2.53917 17.9898 2.67793 18.1304C2.77513 18.2187 2.88674 18.2898 3.00793 18.3404C3.12763 18.3933 3.25706 18.4206 3.38793 18.4206C3.5188 18.4206 3.64823 18.3933 3.76793 18.3404C3.88911 18.2898 4.00073 18.2187 4.09793 18.1304C4.23669 17.9898 4.33068 17.8112 4.36806 17.6172C4.40543 17.4232 4.38451 17.2225 4.30793 17.0404C4.26033 16.9177 4.18897 16.8055 4.09793 16.7104ZM7.38793 8.42041H21.3879C21.6531 8.42041 21.9075 8.31505 22.095 8.12752C22.2826 7.93998 22.3879 7.68563 22.3879 7.42041C22.3879 7.15519 22.2826 6.90084 22.095 6.7133C21.9075 6.52577 21.6531 6.42041 21.3879 6.42041H7.38793C7.12271 6.42041 6.86836 6.52577 6.68082 6.7133C6.49329 6.90084 6.38793 7.15519 6.38793 7.42041C6.38793 7.68563 6.49329 7.93998 6.68082 8.12752C6.86836 8.31505 7.12271 8.42041 7.38793 8.42041ZM4.09793 11.7104C3.9573 11.5717 3.77873 11.4777 3.58474 11.4403C3.39075 11.4029 3.19004 11.4238 3.00793 11.5004C2.88674 11.5511 2.77513 11.6221 2.67793 11.7104C2.58689 11.8055 2.51552 11.9177 2.46793 12.0404C2.41502 12.1601 2.3877 12.2895 2.3877 12.4204C2.3877 12.5513 2.41502 12.6807 2.46793 12.8004C2.51857 12.9216 2.5896 13.0332 2.67793 13.1304C2.77513 13.2187 2.88674 13.2898 3.00793 13.3404C3.12763 13.3933 3.25706 13.4206 3.38793 13.4206C3.5188 13.4206 3.64823 13.3933 3.76793 13.3404C3.88911 13.2898 4.00073 13.2187 4.09793 13.1304C4.18626 13.0332 4.25729 12.9216 4.30793 12.8004C4.36083 12.6807 4.38816 12.5513 4.38816 12.4204C4.38816 12.2895 4.36083 12.1601 4.30793 12.0404C4.26033 11.9177 4.18897 11.8055 4.09793 11.7104ZM21.3879 11.4204H7.38793C7.12271 11.4204 6.86836 11.5258 6.68082 11.7133C6.49329 11.9008 6.38793 12.1552 6.38793 12.4204C6.38793 12.6856 6.49329 12.94 6.68082 13.1275C6.86836 13.3151 7.12271 13.4204 7.38793 13.4204H21.3879C21.6531 13.4204 21.9075 13.3151 22.095 13.1275C22.2826 12.94 22.3879 12.6856 22.3879 12.4204C22.3879 12.1552 22.2826 11.9008 22.095 11.7133C21.9075 11.5258 21.6531 11.4204 21.3879 11.4204ZM4.09793 6.71041C4.00282 6.61937 3.89068 6.548 3.76793 6.50041C3.58582 6.42383 3.3851 6.40291 3.19111 6.44028C2.99712 6.47766 2.81855 6.57165 2.67793 6.71041C2.5896 6.80761 2.51857 6.91923 2.46793 7.04041C2.41502 7.16011 2.3877 7.28954 2.3877 7.42041C2.3877 7.55128 2.41502 7.68071 2.46793 7.80041C2.51857 7.9216 2.5896 8.03321 2.67793 8.13041C2.77513 8.21874 2.88674 8.28977 3.00793 8.34041C3.19004 8.41699 3.39075 8.43791 3.58474 8.40054C3.77873 8.36316 3.9573 8.26917 4.09793 8.13041C4.18626 8.03321 4.25729 7.9216 4.30793 7.80041C4.36083 7.68071 4.38816 7.55128 4.38816 7.42041C4.38816 7.28954 4.36083 7.16011 4.30793 7.04041C4.25729 6.91923 4.18626 6.80761 4.09793 6.71041ZM21.3879 16.4204H7.38793C7.12271 16.4204 6.86836 16.5258 6.68082 16.7133C6.49329 16.9008 6.38793 17.1552 6.38793 17.4204C6.38793 17.6856 6.49329 17.94 6.68082 18.1275C6.86836 18.3151 7.12271 18.4204 7.38793 18.4204H21.3879C21.6531 18.4204 21.9075 18.3151 22.095 18.1275C22.2826 17.94 22.3879 17.6856 22.3879 17.4204C22.3879 17.1552 22.2826 16.9008 22.095 16.7133C21.9075 16.5258 21.6531 16.4204 21.3879 16.4204Z"
                  :fill="modeView === 'tree' ? '#2A5BAD' : 'black'"
                />
              </svg>
            </el-tooltip>
          </div>
          <!--  -->
        </div>
      </div>
    </div>
    <div v-if="getBADT && getBADT.id">
      <ModalAddBenhAn
        ref="ModalUpdateBenhAn"
        @refresh="
          () => {
            $emit('refresh');
          }
        "
        :badt="getBADT"
        :showModalUpdateBenhAn="false"
        :update="true"
      />
    </div>
  </div>
</template>

<script>
import statusBADT from '@/constants/statusBADT'
import ModalAddBenhAn from '@/pages/BenhAn/ModalAddBenhAn.vue'
import appUtils from '@/utils/appUtils'
import { mixinGetPersonInfo } from '@/utils/mixinGetPersonInfo'
import { mixinHasFeatures } from '@/utils/mixinHasFeatures'
import { mapState } from 'vuex'

export default {
  name: 'HeaderEMR',
  props: ['modeView', 'getBADT'],
  components: { ModalAddBenhAn },
  mixins: [mixinGetPersonInfo, mixinHasFeatures],
  data () {
    return {
      statuses: statusBADT,
      statusName: null,
      isSyncing: false,
      isEhcSyncing: false
    }
  },
  mounted () {},
  computed: {
    ...mapState({
      person: state => state.person,
      emrData: state => state.emrData
    }),
    addressPerson () {
      return this.getAddress(this.person)
    }
  },
  methods: {
    showModalUpdateBenhAn (show) {
      this.$refs.ModalUpdateBenhAn.openModal(show)
      // window.$('#modal__update_benhan').modal(show ? 'show' : 'hide')
    },
    getGender () {
      return appUtils.getGender(this.person.gender)
    },
    getYear () {
      if (!this.person.birthday) return ' '
      return ', ' + window.moment(this.person.birthday).format('YYYY')
    },
    download () {
      this.$emit('download')
    },
    getAge () {
      return this.person.birthday ? window.moment().diff(this.person.birthday, 'years', false) : ''
    },
    getStatusMR (status) {
      if (status === undefined || status === null) return ''
      return this.statuses[status].name
    },
    getClassStatusMR (status) {
      if (status === undefined || status === null) return ''
      return this.statuses[status].class
    },
    setStatusMR (item) {
      if (confirm('Bạn có chắc chắn chuyển trạng thái?')) {
        this.statusName = Object.assign({}, item)
        if (this.statusName) this.putMedicalRecord()
      }
    },
    goToMode (mode) {
      if (mode === 'map') {
        this.$router.push({
          name: 'ERMMapView',
          params: { id: this.$route.params.id }
        })
      } else if (mode === 'tree') {
        this.$router.push({
          name: 'ERMTreeView',
          params: { id: this.$route.params.id }
        })
      } else {
        this.$router.push({
          name: 'ElectronicMedicalRecords',
          params: { id: this.$route.params.id }
        })
      }
    },
    backListBADT () {
      this.$router.push({ name: 'ListBenhAn' })
    },
    async putMedicalRecord () {
      try {
        const params = {
          status: this.statusName.status
        }
        await this.$rf.getRequest('DoctorRequest').putMedicalRecord(this.getBADT.id, params)
        this.$emit('refresh')
        this.$toast.open({
          message: 'Thay đổi trạng thái thành công',
          type: 'success'
        })
      } catch (error) {
        this.$toast.open({
          message: 'Thay đổi trạng thái thất bại',
          type: 'error'
        })
      }
    },
    async handleSyncVimes () {
      const self = this

      if (!self.emrData?.ref_id) {
        self.$message({
          type: 'warning',
          message: `Không tìm thấy Mã điều trị`
        })
        return
      }

      try {
        self.isSyncing = true
        const params = {
          medical_record_id: Number(self.emrData?.id || 0)
        }
        await self.$rf
          .getRequest('VimesSyncRequest')
          .vimesSyncData(params)
          .then(async res => {
            if (res?.status !== 'success' || res?.code !== 200) return
            if (res?.data?.code === 401) {
              self.$toast.open({
                type: 'error',
                message: self.$t(`Bạn không thể đồng bộ dữ liệu từ Vimes`)
              })
              console.log(res)
              return
            }
            await self.handleSync2HP()
            self.$toast.open({
              type: 'success',
              message: self.$t(`Đồng bộ dữ liệu thành công`)
            })
            self.isSyncing = false
            self.$emit('refresh')
            self.$eventBus.$emit('syncVimes', {
              message: 'Sync Vimes'
            })
          })
      } catch (error) {
        console.log(error)
        self.$toast.open({
          type: 'error',
          message: self.$t(`Đã có lỗi xảy ra, không thể đồng bộ dữ liệu`)
        })
      } finally {
        self.isSyncing = false
      }
    },
    async handleSyncEhcMedicalRecords () {
      const self = this
      try {
        self.isEhcSyncing = true
        const payload = {
          patient_id: self.emrData?.person?.ehc_ref_id || 0,
          clinic_id: self.emrData?.person?.clinic_id || 0
        }
        const res = await this.$rf.getRequest('EHCSyncRequest').ehcSyncPatientMedicalRecords(payload)
        if (res && (res.status === 'success' || res.status === 200 || res?.data)) {
          self.$toast.open({ type: 'success', message: 'Đồng bộ Hola HIS hoàn tất' })
          self.$emit('refresh')
          self.$eventBus.$emit('syncEHC', {
            message: 'Sync EHC'
          })
        } else {
          self.$toast.open({ type: 'info', message: 'Đồng bộ Hola HIS hoàn tất (không có dữ liệu mới)' })
        }
      } catch (err) {
        console.error('EHC sync error', err)
        self.$toast.open({ type: 'error', message: 'Đồng bộ Hola HIS thất bại' })
      } finally {
        self.isEhcSyncing = false
      }
    },
    async handleSync2HP () {
      try {
        const params = {
          vimes_emr_id: this.emrData?.ref_id,
          type: 'T',
          clinic_id: this.$globalClinic?.id,
          person_id: this.person?.id
        }
        await this.$rf
          .getRequest('VimesSyncRequest')
          .vimesSyncDataSkb(params)
          .then(res => {
            if (res?.data.Status !== 'Success' || res?.status !== 200) return
            if (res?.data?.code === 401) {
              this.$toast.open({
                type: 'error',
                message: this.$t(`Bạn không thể đồng bộ dữ liệu SKB từ Vimes`)
              })
              console.log(res)
            }
          })
      } catch (error) {
        console.log(error)
        this.$toast.open({
          message: 'Đồng bộ dữ liệu sổ khám bệnh thất bại, vui lòng thử lại',
          type: 'error'
        })
      } finally {
        //
      }
    }
  }
}
</script>

